export default __webpack_public_path__ + "static/media/enviro hero image.88a834ee.jpg";